export const minorResultSharedStyles = {
  fadeOverlay: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: 64,
    background: 'linear-gradient(rgba(255, 255, 255, 0), #ffffff)',
    pointerEvents: 'none',
  },
  icon16: {
    width: 16,
    height: 16,
  },
} as const;
